module.exports = __webpack_public_path__ + "assets/img/04.ddf6e2c2.png";